import React from 'react';
import styled from 'styled-components';

/*
 * Styled anchor that opens a link in new window
 */
export const StyledAnchor = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  color: ${({
    theme: {
      colors: {
        text: { link_hover },
      },
    },
  }) => link_hover};

  &:hover {
    color: ${({
      theme: {
        colors: {
          text: { link_hover },
        },
      },
    }) => link_hover};
  }
`;

/*
 * Wraps a text component as a styled link
 */
export const StyledLinkComponent = styled(({ children, ...rest }) => (
  <a {...rest}>{children}</a>
))`
  > * {
    color: ${({
      theme: {
        colors: {
          text: { link },
        },
      },
    }) => link};

    &:hover {
      color: ${({
        theme: {
          colors: {
            text: { link_hover },
          },
        },
      }) => link_hover};
    }
  }
`;
